<template>
  <div
    :style="{ 'min-width': size ? `${size}px` : containerSize }"
    class="d-flex justify-center"
  >
    <template v-if="isSpecialFolder === 'todo'">
      <img
        class="ClosdFildersIcon ClosdFildersIcon-specialFolder"
        src="@/assets/img/icons/folder_calendar.svg"
        alt="todo folder icon"
      />
    </template>
    <template v-else-if="isFolder">
      <v-badge
        color="error"
        :offset-x="1"
        :offset-y="2"
        :model-value="isSpecialFolder === 'new'"
        :dot="true"
      >
        <app-material-icon
          name="folder"
          class="ClosdFildersIcon ClosdFildersIcon-folder text-icon-info"
          filled
          :size="30"
        />
      </v-badge>
    </template>
    <template v-else-if="extension">
      <span v-if="signedFile">
        <span class="icon-wrapper">
          <span style="position: relative">
            <OfficeIcon
              v-if="isOfficeDocument"
              :document-type="officeDocumentType"
              icon-type="document"
              :width="size || 25"
              :height="size || 25"
            />
            <img
              v-else
              class="ClosdFildersIcon"
              :style="{ width: specificSize }"
              :src="fileIcon"
              alt="File icon"
            />
            <span v-if="document.isNew" class="ClosdFildersIcon-new"></span>
          </span>
          <app-material-icon
            name="verified"
            size="xs"
            filled
            color="success"
            class="verified-icon"
          />
        </span>
      </span>
      <span v-else style="position: relative">
        <OfficeIcon
          v-if="isOfficeDocument"
          :document-type="officeDocumentType"
          icon-type="document"
          :width="size || 25"
          :height="size || 25"
        />
        <img
          v-else
          class="ClosdFildersIcon"
          :style="{ width: specificSize }"
          :src="fileIcon"
          alt="File icon"
        />
        <span v-if="document.isNew" class="ClosdFildersIcon-new" data-locator="closd-filders-icon-new"></span>
      </span>
    </template>
  </div>
</template>

<script>
import OfficeIcon from '@/common/office/OfficeIcon.vue'
import { getFileExtension } from '@/common/utils/files'
import { getOfficeDocumentType, isOfficeDocumentExtension } from '@/common/utils/office'
import AppMaterialIcon from '@/design-system/icons/AppMaterialIcon.vue'

export default {
  name: 'ClosdFildersIcon',
  components: { AppMaterialIcon, OfficeIcon },
  props: {
    document: {
      type: [Object, File],
      required: true,
    },
    size: {
      type: [String, Number],
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
    signedFile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isSpecialFolder () {
      return this.document.specialFolder
    },
    isFolder () {
      return this.document.type === 'folder' || this.document.directoryId
    },
    specificSize () {
      if (this.size) {
        return `${this.size}px`
      }
      return false
    },
    containerSize () {
      return this.small ? '35px' : '40px'
    },
    fileExtension () {
      return getFileExtension(this.document)
    },
    isOfficeDocument () {
      return this.fileExtension && isOfficeDocumentExtension(this.fileExtension)
    },
    officeDocumentType () {
      return this.fileExtension ? getOfficeDocumentType(this.fileExtension) : null
    },
    extension () {
      if (this.fileExtension) {
        switch (this.fileExtension.toLowerCase()) {
          case 'doc':
          case 'docx':
          case 'docm':
          case 'dotx':
          case 'dotm':
            return {
              icon: 'doc',
            }
          case 'xls':
          case 'xlt':
          case 'xlm':
          case 'xlsx':
          case 'xlsm':
          case 'xltx':
          case 'xltm':
            return {
              icon: 'excel',
            }
          case 'ppt':
          case 'pptx':
          case 'pps':
            return {
              icon: 'ppt',
            }
          case 'jpg':
          case 'jpeg':
          case 'png':
          case 'gif':
            return {
              icon: 'img',
            }
          case 'zip':
          case 'rar':
          case '7z':
          case 'tar':
          case 'gz':
          case 'bz':
            return {
              icon: 'zip',
            }
          case 'pdf':
            return {
              icon: 'pdf',
            }
        }
      }
      return {
        icon: 'file',
      }
    },
    fileIcon () {
      if (!this.isFolder) {
        return new URL(`../../assets/img/icons/${this.extension.icon}.svg`, import.meta.url).href
      } else {
        return null
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.ClosdFildersIcon {
  position: relative;
  width: 25px;
  vertical-align: middle;
  &.ClosdFildersIcon-specialFolder {
    width: 35px !important;
  }
  &--small {
    font-size: 20px;
    &.ClosdFildersIcon-specialFolder {
      font-size: 27px;
    }
  }
  &-folder {
    width: 30px;
  }
  &-new {
    position: absolute;
    width: 10px;
    height: 10px;
    top: -3px;
    right: -3px;
    background-color: rgb(var(--v-theme-error));
    @include border-radius('border-radius-circle');
  }
  &-folderNew {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 3px;
    right: 0;
    background-color: rgb(var(--v-theme-error));
    @include border-radius('border-radius-circle');
  }
}

.icon-wrapper {
  display: inline-block;
  vertical-align: middle;
  position: relative;

  .verified-icon {
    position: absolute;
    top: -5px;
    right: -4px;
  }
}
</style>
